import React from 'react';
import { HelpRouterFragment } from '../../../models/experiencefragments/help-router';
interface Props {
    helpRouterContent: HelpRouterFragment;
}
const euHelpRouterPopularLinks = (props: Props) => {
    const { helpRouterContent } = props;

    return (
        <div className={'help-router-popular-links'}>
            <p>{helpRouterContent?.mainMenu.sectionTitle}</p>
            <p>
                <a
                    href={
                        helpRouterContent?.mainMenu.recommendedLinks.link1
                            .link1CtaUrlPath
                    }
                    aria-label={
                        helpRouterContent?.mainMenu.recommendedLinks.link1
                            .link1AriaLabel
                    }
                >
                    {
                        helpRouterContent?.mainMenu.recommendedLinks.link1
                            .link1CtaTitle
                    }
                </a>
            </p>
            <p>
                <a
                    href={
                        helpRouterContent?.mainMenu.recommendedLinks.link2
                            .link2CtaUrlPath
                    }
                    aria-label={
                        helpRouterContent?.mainMenu.recommendedLinks.link2
                            .link2AriaLabel
                    }
                >
                    {
                        helpRouterContent?.mainMenu.recommendedLinks.link2
                            .link2CtaTitle
                    }
                </a>
            </p>
            <p>
                <a
                    href={
                        helpRouterContent?.mainMenu.recommendedLinks.link3
                            .link3CtaUrlPath
                    }
                    aria-label={
                        helpRouterContent?.mainMenu.recommendedLinks.link3
                            .link3AriaLabel
                    }
                >
                    {
                        helpRouterContent?.mainMenu.recommendedLinks.link3
                            .link3CtaTitle
                    }
                </a>
            </p>
        </div>
    );
};
export default euHelpRouterPopularLinks;
